import PropTypes from 'prop-types'
import React from 'react'

import './styles.css'

// Proof section (SPEC-053 FR-6), split out of the trial block per Pedro's
// review — the ask and the proof are two sections, not one. Heading matches
// the live page's own copy for this section.
function Testimonials({ testimonials }) {
  if (!testimonials.length) return null
  return (
    <section className="lm-proof">
      <div className="lm-proof__inner wrapper">
        <h2 className="lm-proof__heading">Our students love us</h2>
        <div className="lm-proof__grid">
          {testimonials.map((testimonial) => (
            <figure
              key={testimonial.id || testimonial.text.slice(0, 24)}
              className="lm-proof__item"
            >
              <blockquote>&ldquo;{testimonial.text}&rdquo;</blockquote>
              <figcaption>
                {testimonial.fullName}
                {testimonial.position && (
                  <span className="lm-proof__role">
                    {' '}
                    &middot; {testimonial.position}
                  </span>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}

Testimonials.propTypes = {
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      position: PropTypes.string
    })
  ).isRequired
}

export default Testimonials
